import { useEffect, useState } from "react";

/**
 * @param {number} timeout
 * @returns {{height: number; width: number}}
 */
export function useWindowSize(timeout = 100) {
  const [windowSize, setWindowSize] = useState({
    height: window.innerWidth ?? 0,
    width: window.innerHeight ?? 0,
  });

  let timeoutId = null;

  function handleResize() {
    if (timeoutId) clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      setWindowSize({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, timeout);
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return windowSize;
}
